// VNEC v9 — pages/cashflow.js
// Iframe wrapper cho dashboard BKSNB Cash Flow (file public/cashflow-dashboard.html)
export async function renderCashFlow() {
  window.__pageInit = init;
  return `
    <div class="page" style="padding:0">
      <div class="page-header" style="padding:16px 20px 8px">
        <h1 style="font-family:Cambria,Georgia,serif">CashFlow Dashboard</h1>
        <p class="muted small">Upload file Excel BKSNB để xem phân tích dòng tiền tự động</p>
      </div>
      <div style="padding:0 12px 12px">
        <iframe id="cf-frame" src="/cashflow-dashboard.html"
          style="width:100%;height:calc(100vh - 140px);border:1px solid #EEE;border-radius:8px;background:#f0f2f5"
          title="CashFlow Dashboard"></iframe>
      </div>
    </div>`;
}

function init() { /* iframe loads itself */ }
